import React from 'react';
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import ProspectContactsCustomTabListing
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectContactsCustomTab/components/ProspectContactsCustomTabListing/ProspectContactsCustomTabListing";
import BaseContactTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/BaseContactTab/BaseContactTab";

export default function ProspectContactsCustomTab() {
    const {currentRoute} = useNavigation();
    const {prospect: prospectId} = currentRoute.params;

    return (
        <BaseContactTab
            listingComponent={<ProspectContactsCustomTabListing prospectId={prospectId} currentRoute={currentRoute}/>}
            fetchFormParameters={{tabId: currentRoute.route.metadata.tab_id}}
        />
    )
}
